import { useMemo } from "react"
import { get, sortBy } from "lodash"

import { usePost } from "hooks/post/usePost"
import { SEE_AND_DO_POST_TYPE } from "../constants"
import { useVenue } from "providers/venue"

export const useSeeAndDo = () => {
  const { defaultVenue } = useVenue()
  const { hasData, postData } = usePost(SEE_AND_DO_POST_TYPE)

  const sortedPostByDefaultVenue = useMemo(() => {
    const defaultVenueId = get(defaultVenue, "id")
    return sortBy(postData, [
      // bring only exact 'venue id' to the front
      (data) => {
        const venueId = get(data, "properties.feature.properties.venue_id")
        return venueId !== defaultVenueId
      },
      // then by 'order' ascending
      "properties.order",
    ])
  }, [defaultVenue, postData])

  return {
    hasData,
    postData,
    sortedPostByDefaultVenue,
  }
}
